module.exports = __webpack_public_path__ + "static/img/icon-c-phone.1451ed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-c-phone.png
// module id = Qfk/
// module chunks = 21